<div *ngIf="allowPreview && files.length" class="preview-container">
  <ng-container *ngFor="let file of files; trackBy: trackByFileId">
    <sn-file-preview
      class="file-upload__preview-item"
      [file]="file.nativeFile"
      (removeFile)="onFileRemove(file.id)"
    ></sn-file-preview>
  </ng-container>
</div>

<!-- ngClasses are used instead of ng-containers because the components rely on the uploadInput to remove the file from the preview-->
<div
  class="drop-container"
  [ngClass]="{ 'hide-upload-container': options.maxUploads === 1 && files.length > 0 }"
  *ngIf="options"
  ngFileDrop
  [options]="options"
  [uploadInput]="uploadInput"
  [class.drop-over]="dragOver"
  (uploadOutput)="onUploadOutput($event)"
>
  <h3 class="file-upload__title">
    <span>{{ 'map.fileUpload.dragFilesHere' | t }}</span>
    <label [for]="inputId" class="upload-button" (click)="resetInput()">{{ 'map.fileUpload.browse' | t }}</label>
    <span>{{ 'map.fileUpload.toUpload' | t }}</span>
  </h3>
  <small *ngIf="accept">{{ 'map.fileUpload.allowedFileTypes' | t }} {{ accept }}<br /> </small>
  <small *ngIf="maxFileSize">{{ 'map.fileUpload.maxFileSize' | t }} {{ maxFileSize | snFilesize }}<br /> </small>
  <small *ngIf="allowedContentTypes">{{ 'map.fileUpload.allowedContentTypes' | t }} {{ allowedContentTypes }}<br /> </small>
</div>

<input
  ngFileSelect
  [id]="inputId"
  type="file"
  class="file-upload__hidden-input"
  [ngClass]="{ 'hide-upload-container': this.options.maxUploads === 1 && files.length > 0 }"
  [multiple]="multiple"
  [options]="options"
  [accept]="accept"
  [uploadInput]="uploadInput"
  (uploadOutput)="onUploadOutput($event)"
/>
